import { InfoButton, Input, IconInfoFilled } from '@bbl-digital/snorre'
import { useIsMobile } from '@bbl-digital/snorre-v2'
import { ReactNode } from 'react'
import { InputWrapper, Wrapper } from './styles'

export interface IStyledProps {
  my?: number // Margin bottom & margin top (default: 0em)
  mx?: number // Margin left and right (default: 0em)
  mb?: number // Margin bottom (default: 0em)
  mt?: number // Margin top (default: 0em)
  archiveFilter?: boolean
  hasFilter?: boolean
}

interface IProps extends IStyledProps {
  onDebounceChange: (value: string) => void
  placeholder: string
  value?: string | null
  info?: string
  focus?: boolean
  id?: string
  place?: 'top' | 'left' | 'right' | 'bottom'
  filterButton?: ReactNode
  className?: string
}

const SearchBox: React.FC<IProps> = ({
  onDebounceChange,
  placeholder,
  value,
  info,
  focus,
  id,
  place,
  filterButton,
  className,
  ...rest // Includes my, mx, mb, mt
}) => {
  const isMobile = useIsMobile()

  return (
    <Wrapper {...rest}>
      <InputWrapper hasFilter={Boolean(filterButton)} className={className}>
        <Input
          highlight
          focus={focus}
          placeholder={placeholder}
          debounceDelay={500}
          onDebounceChange={onDebounceChange}
          value={value || ''}
          type="search"
          height="48px"
          id={id}
        />

        {filterButton && filterButton}

        {info && (
          <InfoButton
            aria-label="info om hva som er søkbart i tilknyttet felt"
            width="250px"
            icon={<IconInfoFilled primary />}
            place={!place && isMobile ? 'left' : place || 'top'}
          >
            {info}
          </InfoButton>
        )}
      </InputWrapper>
    </Wrapper>
  )
}

export default SearchBox
